import { render, staticRenderFns } from "./setUpyibiao.vue?vue&type=template&id=756195ab&scoped=true&"
import script from "./setUpyibiao.vue?vue&type=script&lang=js&"
export * from "./setUpyibiao.vue?vue&type=script&lang=js&"
import style0 from "./setUpyibiao.vue?vue&type=style&index=0&id=756195ab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756195ab",
  null
  
)

export default component.exports